import { render, staticRenderFns } from "./PROJECT.vue?vue&type=template&id=2df28d76&"
import script from "./PROJECT.vue?vue&type=script&lang=js&"
export * from "./PROJECT.vue?vue&type=script&lang=js&"
import style0 from "./PROJECT.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports